import React from "react";
import { Modal, ModalBody } from "reactstrap";

import styles from "./DeleteConfirmation.module.scss";

const DeleteConfirmation = ({ message, isOpen, toggle, onSubmit }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <div className={styles.delete_confirmation}>
          <div className={styles.confirmation_msg}>
            <b>{message}</b>
          </div>
          <div className={styles.confirmation_btn}>
            <button className={styles.btn_yes} onClick={() => onSubmit()}>
              Yes
            </button>
            <button className={styles.btn_no} onClick={() => toggle()}>
              No
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteConfirmation;
